import axios from '../../axios'

/*
 * 志愿相关接口
 */
// 使用指导概念及知识
export const concept = (data) => {
    return axios({
        url: '/api/data/wish/concept',
        method: data.method,
        data: data.data
    })
}

// 志愿讲座详情
export const lecture = (data) => {
    return axios({
        url: '/api/data/wish/lecture',
        method: data.method,
        data: data.data
    })
}

// 获取所有分类
export const category = (data) => {
    return axios({
        url: '/api/data/wish/lecture/category',
        method: 'GET',
        data: data
    })
}

// 讲座详情
export const lectureInfo = (data) => {
    return axios({
        url: '/api/data/wish/lecture/info',
        method: 'GET',
        data: data
    })
}

// 使用指导分类管理
export const guideCategory = (data) => {
    return axios({
        url: '/api/data/wish/guideCategory',
        method: data.method,
        data: data.data
    })
}

// 使用指导内容管理
export const guideInfo = (data) => {
    return axios({
        url: '/api/data/wish/guideInfo',
        method: data.method,
        data: data.data
    })
}

// 模糊搜索
export const search = (data) => {
    return axios({
        url: '/api/info/article/search',
        method: 'GET',
        data: data
    })
}

export const categoryList = (data) => {
    return axios({
        url: '/api/data/wish/guide/category',
        method: 'GET',
        data: data
    })
}

// 志愿清单列表
export const auditList = (data) => {
    return axios({
        url: '/api/data/wish/audit',
        method: 'GET',
        data: data
    })
}

// 志愿清单修改
export const auditUpdate = (data) => {
    return axios({
        url: '/api/data/wish/audit',
        method: 'POST',
        data: data
    })
}

export const volList = (data) => {
    return axios({
        url: '/api/data/wish/vol_list',
        method: 'GET',
        data: data
    })
}

// 获取课程列表
export const courseList = (data) => {
    return axios({
        url: '/api/course/list',
        method: 'GET',
        data: data.data
    })
}

// 新建课程
export const addCourse = (data) => {
    return axios({
        url: '/api/course/info',
        method: data.method,
        data: data.data
    })
}

// 修改课程
// export const editCourse = (data) => {
//     return axios({
//         url: '/api/course/info',
//         method: 'PUT',
//         data: data
//     })
// }

// 展示课程详情
export const courseInfo = (data) => {
    return axios({
        url: '/api/course/info',
        method: 'GET',
        data: data
    })
}

// 删除课程
export const deleteCourse = (data) => {
    return axios({
        url: '/api/course/info',
        method: 'DELETE',
        data: data.data
    })
}

// 课时列表
export const getLesson = (data) => {
    return axios({
        url: '/api/course/search/lesson',
        method: 'GET',
        data
    })
}

// 编辑课时列表
export const editLesson = (data) => {
    return axios({
        url: '/api/course/lesson',
        method: 'PUT',
        data
    })
}

// 删除课时信息
export const deleteLesson = (data) => {
    return axios({
        url: '/api/course/lesson',
        method: 'DELETE',
        data: data.data
    })
}

// 添加课时信息
export const addLesson = (data) => {
    return axios({
        url: '/api/course/lesson',
        method: data.method,
        data: data.data
    })
}

// 副号解绑
export const countUnbind = (data) => {
    return axios({
        url: '/api/user/invitation/admin/unbind',
        method: 'get',
        data
    })
}

// 删除用户信息
export const deleteUserInfo = (data) => {
    return axios({
        url: '/api/admin/wish/user',
        method: 'DELETE',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/wish/wish.js